import { render } from "./SkeletonParser.vue?vue&type=template&id=795c97c0&scoped=true"
import script from "./SkeletonParser.vue?vue&type=script&lang=js"
export * from "./SkeletonParser.vue?vue&type=script&lang=js"

import "./SkeletonParser.vue?vue&type=style&index=0&id=795c97c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-795c97c0"]])

export default __exports__